/**
 * Alternador de tema: claro -> oscuro -> segun el sistema.
 *
 * Tres estados y no dos: quien tiene el sistema en oscuro por horario espera que
 * la app lo acompane, y quien quiere fijar uno tiene que poder hacerlo. El
 * `aria-label` dice siempre a que estado se pasa, no en cual se esta.
 */

import { IconMonitor, IconMoon, IconSun } from '@/components/shell/icons';
import { ETIQUETAS_TEMA, useTheme } from '@/components/shell/theme';

export function ThemeToggle() {
  const { preference, cycle } = useTheme();

  const Icono = preference === 'light' ? IconSun : preference === 'dark' ? IconMoon : IconMonitor;
  const siguiente: typeof preference = preference === 'light' ? 'dark' : preference === 'dark' ? 'system' : 'light';

  return (
    <button
      type="button"
      onClick={cycle}
      className="grid h-9 w-9 shrink-0 place-items-center rounded-md text-fg-muted transition-colors hover:bg-fg/5 hover:text-fg"
      aria-label={`${ETIQUETAS_TEMA[preference]}. Cambiar a: ${ETIQUETAS_TEMA[siguiente].toLowerCase()}`}
      title={ETIQUETAS_TEMA[preference]}
    >
      <Icono className="h-[1.125rem] w-[1.125rem]" />
    </button>
  );
}
